import React, { useMemo, useReducer, useRef } from 'react';

import { Container } from '@mui/material';

import { COLORS } from '../../Constant/COLORS';

import Header from './../../Components/Header';
import FormContext from './Components/FormContext';
import Email from './Components/Email';
import VerificationCode from './Components/VerificationCode';
import PasswordReset from './Components/PasswordReset';

import useMultiStepForm from '../../Hooks/useMultiStepForm';

function ForgotPassword() {
  const { CurrentStep, nextStep } = useMultiStepForm([
    Email,
    VerificationCode,
    PasswordReset,
  ]);

  const [inputs, updateInputs] = useReducer(
    (state, fields) => ({ ...state, ...fields }),
    {
      email: '',
      password: '',
      confirmPassword: '',
    }
  );

  const emailOtpReferenceId = useRef(null);

  const formContextValue = useMemo(
    () => ({ nextStep, inputs, updateInputs, emailOtpReferenceId }),
    [emailOtpReferenceId, inputs, nextStep]
  );

  return (
    <FormContext.Provider value={formContextValue}>
      <Header isRegisterProfessionalPage />
      <Container
        maxWidth='sm'
        sx={{
          mx: 'auto',
          boxShadow: `6px 7px 18px ${COLORS.black3}`,
          boxSizing: 'border-box',
          borderRadius: { xs: '12px', md: '31px' },
          marginTop: { xs: '40px', md: '80px' },
          width: '100%',
        }}
      >
        <CurrentStep />
      </Container>
    </FormContext.Provider>
  );
}

export default ForgotPassword;
